import { render, staticRenderFns } from "./TimezoneSection.vue?vue&type=template&id=967bd9aa&scoped=true"
import script from "./TimezoneSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimezoneSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TimezoneSection.vue?vue&type=style&index=0&id=967bd9aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967bd9aa",
  null
  
)

export default component.exports